import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login', '/register']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  
  if (getToken()) {
    if (to.path === '/login' || to.path === '/register') {
      next({ path: '/' })
      NProgress.done()
    } else {
      // 使用 addRouters 长度判断是否已加载动态路由
      const hasRoutes = store.getters.addRouters && store.getters.addRouters.length > 0
      if (!hasRoutes) {
        try {
          // 拉取用户信息
          const res = await store.dispatch('GetInfo')
          const menus = res.data.menus
          const username = res.data.username
          // 生成可访问的路由表
          await store.dispatch('GenerateRoutes', { menus, username })
          // 动态添加可访问路由表
          const addRoutes = store.getters.addRouters
          router.addRoutes(addRoutes)
          // 关键：重新进入当前路由，确保新添加的路由生效
          next({ ...to, replace: true })
        } catch (err) {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/login' })
          })
        }
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})


// WEBPACK FOOTER //
// ./src/permission.js